export type ConnectionType =
    | 'AGENT'
    | 'QC_TRANSFER'
    | 'OUTBOUND_TRANSFER'
    | 'CUSTOMER'
    | 'MONITOR'
    | 'BARGE'
    | 'UNKNOWN';

export type MonitorStatus = 'SILENT_MONITOR' | 'BARGE';

export type CallDirection =
    | 'inbound'
    | 'outbound'
    | 'transfer'
    | 'queue_transfer'
    | 'callback'
    | 'api'
    | 'disconnect'
    | 'monitoring'
    | 'external_outbound'
    | 'unknown';

export type MonitorInfo = {
    status?: MonitorStatus;
    isEnhancedMonitoringEnabled: boolean;
};

export interface CallConnection {
    id: string;
    hold?: boolean;
    activeConnection: boolean;
    status: string | connect.ConnectionStateType;
    number?: string;
    name?: string;
    start?: Date | null;
    initialConnection?: boolean;
    sensitive?: boolean;
    destinationID?: string;
    originNumber?: string;
    contact?: connect.Contact;
    callDirection?: string;
    type?: ConnectionType;
}

export enum Direction {
    INBOUND = 'inbound',
    OUTBOUND = 'outbound',
    CALLBACK = 'callback',
    MONITORING = 'monitoring',
}

export default interface CallState {
    incoming?: boolean;
    callback?: boolean;
    outbound?: boolean;
    connections: Array<CallConnection>;
    inCall?: boolean;
    start?: Date;
    number: string;
    direction: Direction;
    conferenced?: boolean;
    sensitive?: boolean;
    muted?: boolean;
    parking?: boolean;
    monitorInfo: MonitorInfo;
}
